"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('unlock', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    x: "7",
    y: "22.047619",
    width: "34",
    height: "22"
  }), _react.default.createElement("path", {
    d: "M14,22 L14,14.004718 C13.9947898,8.87021688 17.9227159,4.56718073 23.0858694,4.05116974 C28.2490229,3.53515876 32.9673301,6.97408127 34,12.0058975",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M24,30 L24,36",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;